import { render, staticRenderFns } from "./Fault.vue?vue&type=template&id=0c8d6245&scoped=true&"
import script from "./Fault.vue?vue&type=script&lang=js&"
export * from "./Fault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d6245",
  null
  
)

export default component.exports